import { useGetOrderDetailById } from 'shared/hooks';
import { useSubstitutionFlowStatusAlertLang } from './useSubstitutionFlowStatusAlertLang';

import type { OrderId } from 'shared/domain';

export function useSubstitutionFlowStatusAlert(props: Props) {
  const { orderId } = props;

  const {
    data: { substitutionFlowState },
  } = useGetOrderDetailById(orderId);
  const status = substitutionFlowState?.status;
  const _firstProduct = substitutionFlowState?.products?.[0];
  const _firstTopping = substitutionFlowState?.toppings?.[0];

  const outstockItemName = _firstProduct?.name ?? _firstTopping?.name;
  const itemReplacementName =
    _firstProduct?.replacements?.[0]?.name ??
    _firstTopping?.replacements?.[0]?.name;
  const itemWasDeleted = substitutionFlowState?.itemWasDeleted ?? false;
  const isRendered = status !== 'refused' && status !== undefined;

  const lang = useSubstitutionFlowStatusAlertLang({
    status,
    itemWasDeleted,
    outstockItemName,
    itemReplacementName,
  });

  return {
    lang,
    isRendered,
  };
}

interface Props {
  orderId: OrderId;
}
